<template>
  <v-container fluid class="down-top-padding">
    <TicketSummary></TicketSummary>
    <v-row>
     
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title"> Search </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto d-flex">
                  <v-btn color="primary" class="ml-2" >

                    <download-csv :data="exportData" :name="`${fileName}.csv`"  :disabled="!exportData.length">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </div> -->
                <!-- {{ this.exportData }} -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Account Number"
              single-line
              hide-details
              @click:append="searchRecord"
              @keydown.enter.prevent="searchRecord"
              @click:clear="getList()"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :page="table.page"
            :pageCount="table.numberOfPages"
            :options.sync="options"
            :server-items-length="table.total"
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="_id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 20, 50, 100],
            }"
            dense
          >
            <!-- <template slot="body.append">
              <tr>
                <th>Total</th>
                <th class="text-center">
                  {{ setToLocaleString(getTotal(table.data), 0) }}
                </th>
              </tr>
            </template> -->
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <!-- <template v-slot:[`item.subscriberName`]="{ item }">
              <a href="#" @click.prevent="showDetails(item)">{{ item.subscriberName }}</a>
            </template> -->

            <template v-slot:[`item.dateApplied`]="{ item }">
              {{ item.createdDate }}
            </template>

            <template v-slot:[`item.affiliate`]="{ item }">
              <template v-if="item.affiliate && Object.keys(item.affiliate).length !== 0">
                {{ `${item.affiliate.firstname} ${item.affiliate.lastname}` }}
                - {{ item.affiliate.msisdn }}
              </template>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <online-application-dialog ref="onlineAppDialog"></online-application-dialog>
  </v-container>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";
import OnlineApplicationDialog from "../dialogs/pds/pdsInfoDialog.vue";
import TicketSummary from "./components/TicketSummaryReport.vue"
export default {
  mixins: [ShareableMethods],
  name: "OnlinePastDue",
  components: { OnlineApplicationDialog,TicketSummary },
  data() {
    return {
     
      exportData: [],
      fileName: "",

      search: "",
      table: {
        page: 0,
        total: 0,
        numberOfPages: 0,

        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          { text: "Name", value: "subscriberName" },
          { text: "Account Number", value: "subscriberNumber" },
          { text: "Distributor", value: "currentStatus.distributor" },
          { text: "Date Assigned to Distributor", value: "currentStatus.dateAsssigned", formatter: (x) => (x ? this.formatDate(x) : null),},
          { text: "Status", value: "currentStatus.status" },
          // { text: "Disconnection Date", value: "disconnectionDate" , formatter: (x) => (x ? this.formatDate(x) : null)},
          // // { text: "Mobile Number", value: "mobileNumber" },
          // // { text: "Affiliator Details", value: "affiliate" },
          // { text: "Customer Type", value: "typeOfCustomer" },
          // { text: "Subscription", value: "subscriptionPackageName" },
          
          // {
          //   text: "Date Uploaded",
          //   value: "createdAt",
          //   formatter: (x) => (x ? this.formatDate(x) : null),
          // },
          
          
          // {
          //   text: "Next Call Date",
          //   value: "nextCall.date",
          //   formatter: (x) =>
          //     x ? this.formatDate(x, "ddd MMM. DD") : null,
          // },

          // {
          //   text: "Retry",
          //   value: "nextCall.retry",
         
          // },
        ],
        data: [],
      },

      options: {
        page: 1,
      },
     
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    
    async getList(searchVal = "") {
      this.table.loading = true;
      const { page, itemsPerPage } = this.options;
      let pageNumber = "";
      if (itemsPerPage === -1) {
        pageNumber = "";
      } else {
        pageNumber = page ? page : 1;
      }

      const perPage = itemsPerPage < 0 ? "" : itemsPerPage;

      await this.$pds
        .get(
          `/pds?status=FOR_CONFIRMATION&type=ECS&page=${pageNumber}&limit=${perPage}&searchVal=${searchVal}`
        )
        .then((response) => {
          const newArr = response.data;
          // newArr.subscribers.map((obj) => {
          //   obj.customer = obj.firstName + " " + obj.lastName;
          // });
          // this.table.data = newArr.customers.sort(function(a, b) {
          //   return b["count"] - a["count"];
          // });//test//test //test
          this.table.data = newArr.data.customers;
          this.table.total = newArr.totalCount;
          this.table.numberOfPages = newArr.totalPages;
     //this.exportData=response.data.customers;
         this.exportExcel(newArr.data.customers);
          this.table.loading = false;
        })
        .catch(() => {
          this.table.loading = false;
          //console.log(e);
        });
    },
    async getSearch(searchVal) {
      this.table.loading = true;
      
      await this.$pds
        .get(
          `/pds/search-subscriber-number?searchVal=${searchVal}`
        )
        .then((response) => {
          const newArr = response.data;
         
          this.table.data = newArr.data.customers;
          this.table.total = newArr.totalCount;
          this.table.numberOfPages = newArr.totalPages;
          const newArrCust = response.data.data.customers;
         
          for (var x = 0; x < newArrCust.length; x++) {
            var obj = {};
            obj["Name"] = newArrCust[x]["subscriberName"];
            obj["Email Address"] = newArrCust[x]["emailAddress1"];
            obj["Customer Type"] = newArrCust[x]["typeOfCustomer"];
            obj["Subscription"] = newArrCust[x]["subscriptionPackageName"];
            obj["Contact Number"] = newArrCust[x]["mobile1"];
            obj["Address"] = newArrCust[x]["address"];
            obj["Barangay"] = newArrCust[x]["barangayName"];
            obj["City"] = newArrCust[x]["municipalityName"];
            obj["Subscription"] = newArrCust[x]["subscriptionPackageName"];
            obj["Type"] = newArrCust[x]["typeOfCustomer"];
            obj["Nap Code"] = newArrCust[x]["napCode"];
            obj["Port No"] = newArrCust[x]["portNo"];
            obj["Subscriber Number"] = newArrCust[x]["subscriberNumber"];
            obj["Disconnection Date"] = this.formatDate(
              newArrCust[x]["disconnectionDate"] ,
            "ddd MMM. DD, YYYY HH:ss A"
          );
            this.exportData.push(obj);
          }
          this.fileName = "NOT_INTERESTED";
          this.table.loading = false;
        })
        .catch(() => {
          this.table.loading = false;
         
        });
    },
    getTotal(data) {
      return data.reduce((partialSum, a) => partialSum + a.count, 0);
    },

    async showDetails(item) {
      await this.$refs.onlineAppDialog.open(item, "cancelled").then((response) => {
        if (response) {
          // this.table.selected = [];
          this.getList();
        }
      });
    },

    exportExcel(items) {
     console.logs("MALI",items);
      let exportData2 = items.map((item) => {
        return {
          "Name": item.subscriberName,
          "Email Address": item.emailAddress1,
          //"Disconnection Date": item.disconnectionDate,
          "Customer Type": item.typeOfCustomer,
          "Subscription": item.subscriptionPackageName,
          "Contact Number": item.mobile1,
          // "Affiliator Name":
          //   item.affiliate && Object.keys(item.affiliate).length !== 0
          //     ? `${item.affiliate.firstname} ${item.affiliate.lastname}`
          //     : "",
          // "Affiliator Number":
          //   item.affiliate && Object.keys(item.affiliate).length !== 0
          //     ? item.affiliate.msisdn
          //     : "",
          //Address: `${item.address} ${item.village}, ${item.barangay}, ${item.city}, ${item.province}, ${item.region}`,
          "Barangay": item.barangayName,
          "City": item.municipalityName,
          "Province": item.provinceName,
          "Region":item.region,
          "Plan": item.subscriptionPackageName,
          "Type": item.cutypeOfCustomer,
          "NapCode": item.napCode,
          "portNo": item.portNo,
          //Region: item.region,
         // "Disconnection Date": this.formatDate(item.disconnectionDate),
          "Disconnection Date": this.formatDate(
            item.disconnectionDate,
            "ddd MMM. DD, YYYY HH:ss A"
          ),
          // "SKU Name": item.sku.skuName,
          // "SKU Price": item.sku.price,
          // "Next Call Date": item.nextCallDate,
        };
      });
      this.fileName = `FOR_CONFIRMATION`;
      this.exportData = exportData2;
    },

    searchRecord() {
      this.options.page = 1;
      if (!this.search) {
        return;
      }
    if(this.search != "")
    {
      this.getSearch(this.search);
    }
    // else{
    //   this.getList();
    // }
      
    },
    
  },

  mounted() {

   // this.getList();
   

    // console.log(this.$props.headers);
  },

  computed: {
   
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },

    options: {
      handler() {
        //this.getList(this.search);
       
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
